import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BedFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.5 11V6.51066C6.78067 4.9024 9.08153 4 12 4C14.9185 4 17.2193 4.9024 19.5 6.51066V11H18.25V9.5C18.25 8.80964 17.6904 8.25 17 8.25H13.5C12.8096 8.25 12.25 8.80964 12.25 9.5V11H11.75V9.5C11.75 8.80964 11.1904 8.25 10.5 8.25H7C6.30964 8.25 5.75 8.80964 5.75 9.5V11H4.5ZM2.5 11.4013V6.50333C2.5 5.87459 2.79678 5.26522 3.33078 4.88792C5.8863 3.08228 8.58595 2 12 2C15.414 2 18.1137 3.08228 20.6692 4.88792C21.2032 5.26522 21.5 5.87459 21.5 6.50333V11.4013C22.3967 11.9201 23 12.8896 23 14V17.5V21C23 21.5523 22.5523 22 22 22C21.4477 22 21 21.5523 21 21V18.5H3V21C3 21.5523 2.55228 22 2 22C1.44772 22 1 21.5523 1 21V17.5V14C1 12.8896 1.6033 11.9201 2.5 11.4013Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BedFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BedFilledIcon;
